import * as React from 'react';

export class StyleProvider extends React.Component {
  render() {
    const { children } = this.props;
    return <>{React.Children.only(children)}</>;
  }
}
export default StyleProvider;
